module.exports = __webpack_public_path__ + "static/media/globe.2400a989.png";